import React from "react";

interface LiquidityIconProps {
  size?: number | string;
  color?: string;
}

const LiquidityIcon = ({ size, color = "#002035" }: LiquidityIconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M5.13958 2.58824L4.74658 2.19525L5.64771 1.29412L4.74658 0.392993L5.13958 0L6.4337 1.29412L5.13958 2.58824Z"
      fill={color}
    />
    <path
      d="M1.21315 10.8406L0.659668 10.7921L0.821711 8.94562L2.63997 9.14056L2.58084 9.69315L1.32562 9.55845L1.21315 10.8406Z"
      fill={color}
    />
    <path
      d="M9.71526 9.6171L9.23047 7.87197L9.76594 7.72327L10.1045 8.94204L11.3219 8.6264L11.4615 9.16432L9.71526 9.6171Z"
      fill={color}
    />
    <path
      d="M0.404774 8.56182C0.136036 7.90498 0 7.21412 0 6.50816C0 5.04044 0.57104 3.66096 1.60776 2.62424C2.64448 1.5873 4.02396 1.01648 5.49168 1.01648H6.04049V1.57218H5.49168C4.17222 1.57218 2.93256 2.08543 2.00053 3.01723C1.06873 3.94904 0.555481 5.18892 0.555481 6.50838C0.555481 7.14188 0.677735 7.76183 0.918911 8.35154L0.404774 8.56182Z"
      fill={color}
    />
    <path
      d="M5.49148 12C3.61098 12 1.87185 11.0391 0.839355 9.42978L1.30704 9.1297C2.23684 10.579 3.80103 11.4443 5.49126 11.4443C6.20389 11.4443 6.88874 11.2969 7.52691 11.0062C8.14574 10.7243 8.69322 10.3211 9.15379 9.80766L9.56745 10.1789C9.05532 10.7497 8.44626 11.198 7.75741 11.5119C7.04656 11.8358 6.28413 12 5.49148 12Z"
      fill={color}
    />
    <path
      d="M10.1461 9.42614L9.674 9.13317C10.1672 8.33829 10.428 7.43049 10.428 6.50803C10.428 4.29077 8.93247 2.33581 6.79102 1.75432L6.93661 1.21796C9.31946 1.86524 10.9835 4.04048 10.9835 6.50803C10.9837 7.53408 10.6941 8.54323 10.1461 9.42614Z"
      fill={color}
    />
    <path
      d="M5.83497 6.9087H4.09473V4.59808H5.83497C6.47202 4.59808 6.99016 5.11644 6.99016 5.75328C6.99016 6.39011 6.47202 6.9087 5.83497 6.9087ZM4.65043 6.35299H5.83497C6.15994 6.35299 6.43446 6.07848 6.43446 5.7535C6.43446 5.42297 6.1655 5.15401 5.83497 5.15401H4.65043V6.35299Z"
      fill={color}
    />
    <path
      d="M5.83497 8.66352H4.09473V6.35291H5.83497C6.47202 6.35291 6.99016 6.87126 6.99016 7.5081C6.99016 8.14494 6.47202 8.66352 5.83497 8.66352ZM4.65043 8.10781H5.83497C6.15994 8.10781 6.43446 7.8333 6.43446 7.50832C6.43446 7.17779 6.1655 6.90883 5.83497 6.90883H4.65043V8.10781Z"
      fill={color}
    />
    <path d="M5.82035 4.01324H5.26465V5.15399H5.82035V4.01324Z" fill={color} />
    <path d="M5.82035 8.10785H5.26465V9.2486H5.82035V8.10785Z" fill={color} />
  </svg>
);

export default LiquidityIcon;
